const creatureNames = {
  '淺瀨旬魚': 'Shallow Shun Fish',
  '銀背鯵群': 'Silverback Aji School',
  '逆流鮭群': 'Upstream Salmon School',
  '疾游鰤': 'Swift Yellowtail',
  '青銀鯖群': 'Blue-Silver Mackerel School',
  '星幕鰯群': 'Starlit Sardine School',
  '旬光鯛': 'Seasonlight Sea Bream',
  '洄游鰹': 'Migrating Bonito',
  '水刃飛魚': 'Waterblade Flying Fish',
  '桶隙穴子': 'Oke-Crevice Anago',
  '墨隱烏賊': 'Ink-Hidden Squid',
  '擬木蛸': 'Wood-Mimic Octopus',
  '鏽甲蟹': 'Rustshell Crab',
  '深棘海膽': 'Deep-Spine Uni',
  '磷光海月': 'Phosphorescent Jellyfish',
  '潮音古貝': 'Ancient Tide Shell',
  '幽燈鮟鱇': 'Ghost-Lantern Anglerfish',
  '盲眼深海魚': 'Blind Abyssal Fish',
  '古層記憶魚': 'Ancient Memory Fish',
  '銀鰯怨靈': 'Silver Sardine Wraith',
  '無名板前影': 'Nameless Itamae Shade',
  '古木盲鰻': 'Ancient-Wood Blind Eel',
  '墨潮殘靈': 'Ink-Tide Remnant',
  '貓板前': 'Cat Itamae',
  '始祖鮭神・紅洄': 'Primordial Salmon God · Kōkai',
  '神代金鮭': 'Divine-Age Golden Salmon',
  '始祖玉子神・天黃': 'Primordial Tamago God · Tenkō',
  '半熟膜游靈': 'Soft-Yolk Membrane Spirit',
  '始祖甘海老神・櫻躍': 'Primordial Amaebi God · Sakura Leap',
  '神代櫻甲蝦': 'Divine-Age Sakura Shrimp',
  '始祖烏賊神・無星墨': 'Primordial Squid God · Starless Ink',
  '宇宙墨眷': 'Cosmic Ink Familiar',
  '始祖海膽神・金爆': 'Primordial Uni God · Golden Burst',
  '日輪神棘': 'Solar Divine Spine',
  '始祖鯖神・銀河主': 'Primordial Mackerel God · Galaxy Lord',
  '星界神鯖': 'Astral Divine Mackerel',
  '始祖鮪神・天衡眼': 'Primordial Tuna God · Eye of Judgment',
  '御前赤身衛': 'Akami Divine Guard',
  '始祖鯨神・百層鳴': 'Primordial Whale God · Hundred-Layer Song',
  '神歌幼鯨影': 'Divine-Song Calf Spirit',
  '眾旬神・萬味座': 'Assembly of Shun Gods · Seat of All Flavors',
  '始祖板前・無名御影': 'Primordial Itamae · Nameless Shade',
  '百旬神使': 'Divine Envoy of the Hundred Seasons',
  '旬之始祖・源心': 'Primordial Shun · Heart of the Source',
  '百年味噌心靈': 'Century Miso Heart-Spirit',
  '一期一會原生魚': 'Once-in-a-Lifetime Origin Fish'
};

const creatureBehaviors = {
  fish: 'Moves with the floor current and feeds along the boundary between light and shadow.',
  salmon: 'Swims against the current, guided by a distant ancestral heartbeat.',
  tuna: 'Cuts through nearby schools at great speed before diving into deeper water.',
  mackerel: 'Forms a rapid silver line along the boundary between currents.',
  school: 'Gathers into a flashing silver curtain whenever danger approaches.',
  'flying-fish': 'Leaps above the surface and slices through the current with blade-like fins.',
  eel: 'Waits beneath sediment and inside cracks in the ancient wooden oke.',
  squid: 'Releases a cloud of ink, then approaches silently from another direction.',
  octopus: 'Camouflages itself against lacquer and century-old wood grain.',
  crab: 'Builds nests from sunken fragments and guards passages along the floor.',
  urchin: 'Forms dense, untouchable colonies across the sediment.',
  jellyfish: 'Contracts with the pressure tide and releases a soft blue glow.',
  shell: 'Lies beneath the sediment and answers the tide with a hollow song.',
  angler: 'Uses its solitary lantern to lure the lost into lightless water.',
  whale: 'Travels between layers by following the resonance of an ancient song.',
  spirit: 'Takes form from memories, forgotten techniques and feelings left unfinished.',
  cat: 'Watches from the oke rim and steals the finest fish when no one is looking.'
};

const realmLabels = {
  Shallow: 'Sunlit Migration Waters',
  Deep: 'Bioluminescent Pressure Zone',
  Ancient: 'Ancient Memory Stratum',
  Mythical: 'Sacred Bloodline Domain'
};

function titleFromScene(scene) {
  return scene
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function getEnglishEnvironment(floor) {
  if (floor.floor === 30) {
    return [
      'The Century-Old Diagnosis Table',
      'Windless White-Sand Court',
      'Glowing Questionnaires of Unspoken Hearts'
    ];
  }

  if (floor.floor === 60) {
    return [
      'Black Torii of the Keeper Flame',
      'Underwater Hearth That Never Dies',
      'Warm Charcoal Resting Ground'
    ];
  }

  if (floor.floor === 90) {
    return [
      'Clear Dashi of No-Mind',
      'Vessel Capable of Holding Every Flavor',
      'Chamber of Absolute Silence'
    ];
  }

  return [
    `${floor.name_en} · Primary Scene`,
    `${titleFromScene(floor.scene)} · Narrative Landmark`,
    realmLabels[floor.realm]
  ];
}

export function translateCreature(creature) {
  return {
    ...creature,
    name_en: creatureNames[creature.name] || creature.name,
    behavior_en: creatureBehaviors[creature.type] || creatureBehaviors.fish
  };
}

export function getEnglishResource(resource) {
  const resources = {
    '發光問診票': 'Glowing Questionnaire',
    '白砂': 'Windless White Sand',
    '百年桌木屑': 'Century-Old Table Shavings',
    '守火炭': 'Keeper-Flame Charcoal',
    '溫熱爐灰': 'Warm Hearth Ash',
    '黑鳥居漆片': 'Black Torii Lacquer Fragment',
    '透明高湯': 'Clear Dashi',
    '金色注連繩纖維': 'Golden Shimenawa Fiber',
    '無味水晶': 'Flavorless Crystal'
  };

  return resources[resource] || resource;
}